export default __webpack_public_path__ + "static/media/DinosaursFlyingRetiples_03.2eb899ca.png";